export const personalInfo = {
    location: {
        city: "Bristol",
        region: "England",
        country: "United Kingdom",
    },
    experience: [
        {
            year: '2024',
            title: 'Tech Lead - Frontend',
            company: 'Cureoscity',
            period: 'Mar 2024-present',
            description: 'Leading frontend development teams and implementing key features ',
            details: 'Leading frontend development teams and implementing key features',
            location: 'Bristol, England'
        },
        {
            year: '2023',
            title: 'Senior Frontend Developer',
            company: 'Cureoscity',
            period: 'Jan 2023-Mar 2024',
            description: 'Frontend development with TypeScript and modern web technologies',
            details: 'Frontend development with TypeScript and modern web technologies',
            location: 'Remote'
        },
        {
            year: '2022',
            title: 'Founder & Lead Dev',
            company: 'Fccview Labs Ltd',
            period: 'Jan 2022-Jan 2023',
            description: 'Building React web applications, Full stack development, Blockchain development',
            details: 'Building React web applications, Full stack development (React/Next.js/MongoDB/Solidity/RestAPI/GraphQL), Bots and automation development, Converting beautiful designs into great user experiences',
            location: 'Bristol, England'
        },
        {
            year: '2020',
            title: 'Lead of Frontend Development',
            company: 'The Pixel',
            period: 'Jul 2020-Jan 2022',
            description: 'Managing team of 6-8 frontend developers, PWA development',
            details: 'Managing a team of 6-8 frontend developers, Heading new PWA development team, Magento 2 Development, Rest API Development, Managing deployments on AWS',
            location: 'Bristol, England'
        },
        {
            year: '2017',
            title: 'Full-stack Developer',
            company: 'The Pixel',
            period: 'Feb 2017-Jul 2020',
            description: 'Full stack development and frontend specialization',
            details: 'Full stack development with focus on frontend technologies',
            location: 'Bristol, United Kingdom'
        },
        {
            year: '2015',
            title: 'Full-stack Developer',
            company: 'T&S Creative Communications',
            period: 'Oct 2015-Feb 2017',
            description: 'Full Stack Development with Javascript/Angular/Vue/Wordpress',
            details: 'Full Stack Developer / Designer, Managing existing websites, Digital graphic design, HTML5 Web Ads, Working with external APIs',
            location: 'Bristol, United Kingdom'
        }
    ],
    skills: [
        'React', 'TypeScript', 'Next.js', 'Node.js', 'MongoDB',
        'Solidity', 'REST API', 'GraphQL', 'Magento', 'PWA',
        'AWS', 'WordPress', 'HTML5', 'CSS3', 'Tailwind CSS', 'SCSS',
        'Socket.io', 'WebSocket', 'Remix', 'WalletConnect',
        'RainbowKit', 'Smart Contracts', 'ERC1155',
        'Alchemy', 'Web3', 'Yarn'
    ],
    education: [
        {
            school: 'IT B.Focaccia',
            degree: 'IT Liceo (A Levels)',
            field: 'Information Technology',
            period: '2006-2011',
            grade: '83/100'
        },
        {
            school: 'Salerno Formazione',
            degree: 'Specialization',
            field: 'Graphic Design',
            period: '2013-2014'
        }
    ],
    certifications: [
        {
            name: 'Adobe Certified Expert-Adobe Commerce Front-End Developer',
            issuer: 'Adobe Commerce',
            date: 'Jun 2021'
        },
        {
            name: 'Adobe Certified Professional—Magento Commerce Developer',
            issuer: 'Adobe',
            date: 'Nov 2018'
        }
    ],
    languages: [
        { name: 'English', level: 'Full professional proficiency' },
        { name: 'Italian', level: 'Native or bilingual proficiency' }
    ],
    summary: 'A seasoned web developer with over a decade of experience crafting dynamic, user-centric websites and web applications. I specialize in frontend development, leveraging my deep expertise in JavaScript frameworks—particularly React—to build scalable, high-performance solutions. Passionate about clean, maintainable code, I thrive at the intersection of innovation and practicality, delivering seamless digital experiences that leave a lasting impression.',
    contact: 'https://www.ffklabs.digital',
    currentRole: {
        position: "Tech Lead - Frontend",
        workStyle: "Remote",
        focus: "JavaScript/TypeScript Ecosystem"
    },
    projects: [
        {
            title: 'FFKLabs',
            description: 'Previous portfolio website showcasing web development and blockchain projects',
            tech: ['React', 'Next.js', 'Tailwind CSS'],
            image: 'https://www.ffklabs.digital/images/preview-meta.png',
            link: 'https://ffklabs.digital',
            slug: 'ffklabs'
        },
        {
            title: 'Dorkis',
            description: 'A cute, goofy & handdrawn 4724 generated collection',
            tech: ['Smart Contract', 'Web3', 'Art Generation'],
            image: 'https://ffklabs.digital/images/assets/websites/dorkis_logo.jpg',
            link: 'https://ffklabs.digital/clients/dorkis',
            slug: 'dorkis'
        },
        {
            title: 'DayJob Punks',
            description: 'PERFECT DAYJOBS DURING A BEAR MARKET. We help mint the best job to build your future.',
            tech: ['Smart Contract', 'Web3', 'Art Generation'],
            image: 'https://ffklabs.digital/images/assets/websites/dayjobpunks_logo.jpg',
            link: 'https://ffklabs.digital/clients/dayjobpunks',
            slug: 'dayjobpunks'
        },
        {
            title: 'OneOnes',
            description: '6565 companions that will transport you to the Magical World created by Migratinglines.',
            tech: ['Smart Contract', 'Web3', 'Art Generation'],
            image: 'https://ffklabs.digital/images/assets/websites/oneones_logo.jpg',
            link: 'https://ffklabs.digital/clients/oneones',
            slug: 'oneones'
        },
        {
            title: 'All Access Calladita',
            description: 'A unique Behind-the-Scenes experience by Calladita, powered by BEEM.xyz',
            tech: ['Smart Contract', 'Web3', 'Design'],
            image: 'https://ffklabs.digital/images/assets/websites/calladita_logo.jpg',
            link: 'https://ffklabs.digital/clients/calladita',
            slug: 'calladita'
        },
        {
            title: 'Nightmare Realm',
            description: 'Humankind has failed. Now it\'s my time to rise, my destiny.',
            tech: ['Smart Contract', 'Web3', 'Art Generation'],
            image: 'https://ffklabs.digital/images/assets/websites/nightmarerealm_logo.jpg',
            link: 'https://ffklabs.digital/clients/nightmarerealm',
            slug: 'nightmarerealm'
        },
        {
            title: 'Bulk (formerly Bulk Powders)',
            description: 'As Frontend Lead at The Pixel, led development of the e-commerce platform for one of UK\'s largest sports nutrition brands. Implemented responsive design, performance optimizations, and complex product filtering systems.',
            tech: ['Magento', 'PHP', 'JavaScript', 'React', 'Frontend'],
            image: 'https://www.bulk.com/uk/media_19f3899cfab3ae74735112074d5803ba61dc3b54b.jpeg?width=1200&format=pjpg&optimize=medium',
            url: 'https://www.bulk.com/uk/'
        },
        {
            title: 'Science in Sport',
            description: 'Led frontend development for premium sports nutrition e-commerce platform. Implemented performant product catalog, checkout flow optimizations, and responsive designs.',
            tech: ['Magento', 'PHP', 'JavaScript', 'React', 'Frontend'],
            image: 'https://www.scienceinsport.com/media/wysiwyg/Phoenix_-_Homepage_Product_Category_-_576_x_900_-_Energy.jpg',
            url: 'https://www.scienceinsport.com/'
        },
        {
            title: 'National Trust Shop',
            description: 'Frontend Lead for the e-commerce platform of UK\'s largest conservation charity. Implemented accessible design patterns and optimized performance for large product catalog.',
            tech: ['Magento', 'PHP', 'JavaScript', 'React', 'Frontend'],
            image: 'https://nt.global.ssl.fastly.net/binaries/content/gallery/website/national/regions/lake-district/places/borrowdale-and-derwent-water/library/summer/rangers-repairing-drystone-walls-at-moss-mire-at-borrowdale-and-derwent-water-cumbria-1831043.jpg?auto=webp&width=1200&crop=16:9',
            url: 'https://shop.nationaltrust.org.uk/'
        },
        {
            title: 'Vivobarefoot',
            description: 'Led frontend development for sustainable footwear brand\'s e-commerce platform. Implemented complex product customization features and responsive design system.',
            tech: ['Magento', 'PHP', 'JavaScript', 'React', 'Frontend'],
            image: 'https://www.vivobarefoot.com/media/wysiwyg/Primus_Trail_III_Pebble_HP_Banner_2_desktop_914x1142.jpg?quality=80&bg-color=255%2C255%2C255&fit=bounds&height=1737&width=1390',
            url: 'https://www.vivobarefoot.com/'
        },
    ],
    expertise: {
        frontend: ["React", "Next.js", "TypeScript", "Magento", "PHP", "JavaScript", "React", "Frontend", "Remix"],
        backend: ["Node.js", "MongoDB", "WebSocket", "Socket.io"],
        blockchain: ["WalletConnect", "ERC721", "ERC1155", "ERC20", "Alchemy", "Infura", "Web3.js", "RainbowKit", "Smart Contracts"],
        tools: ["Yarn", "NPM", "Git", "VS Code", "Cursor", "ChatGPT", "Docker", "AWS", "Cloudflare",]
    }
}; 